export default "__VITE_ASSET__BrTd2iHN__"